import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import ProactiveITManagement from './pages/ProactiveITManagement';
import SecurityThreatProtection from './pages/SecurityThreatProtection';
import CloudBackupRecovery from './pages/CloudBackupRecovery';
import Office365CloudProductivity from './pages/Office365CloudProductivity';
import UnlimitedSupport from './pages/UnlimitedSupport';
import ManagedServicePlans from './pages/ManagedServicePlans';
import Consulting from './pages/Consulting';
import ThankYou from './pages/ThankYou';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <ScrollToTop />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
          <Route path="/services/proactive-it-management" element={<ProactiveITManagement />} />
          <Route path="/services/security-threat-protection" element={<SecurityThreatProtection />} />
          <Route path="/services/cloud-backup-recovery" element={<CloudBackupRecovery />} />
          <Route path="/services/office-365-cloud-productivity" element={<Office365CloudProductivity />} />
          <Route path="/services/unlimited-support" element={<UnlimitedSupport />} />
          <Route path="/services/managed-service-plans" element={<ManagedServicePlans />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
        </main>
        <footer className="footer">
          <p>&copy; 2026 Rev-Tech. All rights reserved. | Managed Service Provider | Greater Tampa Bay Area</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
